import cn from 'classnames'
import React from 'react'

import styles from './TagsGroup.module.scss'

import Tag, { TagProps } from '~lib/ui-kit/tags/TagOld'
import Tooltip from '~shared/ui/Tooltip'

interface TagGroupItem {
  id: string
  label?: string
  color?: string
}
export interface TagsGroupProps extends React.HTMLAttributes<HTMLElement> {
  tags: TagGroupItem[]
  bordered?: boolean
  variant?: TagProps['variant']
  size?: TagProps['size']
  color?: string
  compact?: boolean
}

const tooltipDelay = {
  open: 800,
  close: 100,
}

function TagsGroup({
  tags,
  bordered = true,
  variant = 'light',
  size = 'sm',
  compact,
  color,
  className,
  ...props
}: TagsGroupProps) {
  return (
    <div className={cn(styles.root, compact && styles.compact, className)} {...props}>
      {tags.map((tag) => {
        return (
          <div key={tag.id} className={styles.item}>
            <Tooltip key={tag.id} delay={tooltipDelay} content={tag.label}>
              <Tag
                value={tag.id}
                label={tag.label}
                color={color || tag.color}
                variant={variant}
                size={size}
                bordered={bordered}
                className={styles.tag}
              />
            </Tooltip>
          </div>
        )
      })}
    </div>
  )
}

export default TagsGroup
